import { render, staticRenderFns } from "./ArenaSignEditDocumentTypes.vue?vue&type=template&id=1edbaf9c&"
import script from "./ArenaSignEditDocumentTypes.vue?vue&type=script&lang=ts&"
export * from "./ArenaSignEditDocumentTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports